// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml from "../../../../node_modules/rescript/lib/es6/caml.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as CSS$Showside from "./CSS.bs.js";
import * as ObjectFitMath$Showside from "./ObjectFitMath.bs.js";
function RectToRectTransition(Props) {
  var largeContainer = Props.largeContainer;
  var smallContainer = Props.smallContainer;
  var naturalSize = Props.naturalSize;
  var smallFitRule = Props.smallFitRule;
  var largeFitRule = Props.largeFitRule;
  var duration = Props.duration;
  var render = Props.render;
  var largeFit = ObjectFitMath$Showside.fitAndPosition({
    width: largeContainer.width,
    height: largeContainer.height
  }, naturalSize, largeFitRule);
  var render2 = function (sx, sy, tx, ty, invSx, invSy) {
    var transitionDuration = duration === 0 ? undefined : "" + String(duration) + "ms";
    var outerTransform = CSS$Showside.translateAndScale(tx, ty, sx, sy);
    var innerTransform = CSS$Showside.scale(invSx, invSy);
    var scaleUp = 1.0 / Caml.float_max(sx * invSx, sy * invSy);
    var tmp = {
      height: "" + String(largeFit.height) + "px",
      width: "" + String(largeFit.width) + "px",
      transform: outerTransform,
      transformOrigin: "top left"
    };
    if (transitionDuration !== undefined) {
      tmp.transitionDuration = transitionDuration;
    }
    var tmp$1 = {
      height: "" + String(largeFit.height) + "px",
      width: "" + String(largeFit.width) + "px",
      transform: innerTransform
    };
    if (transitionDuration !== undefined) {
      tmp$1.transitionDuration = transitionDuration;
    }
    return React.createElement("div", {
      className: CSS$Showside.prefix("pointer-events-none absolute inset-0 flex items-center justify-center")
    }, React.createElement("div", {
      className: CSS$Showside.prefix("flex-shrink-0 pointer-events-auto ease-fastoutslow overflow-hidden transition-transform"),
      style: tmp
    }, React.createElement("div", {
      className: CSS$Showside.prefix("ease-fastoutslow transition-transform flex items-center"),
      style: tmp$1
    }, Curry._1(render, scaleUp))));
  };
  if (smallContainer === undefined) {
    return render2(1.0, 1.0, 0, 0, 1.0, 1.0);
  }
  var smallFit = ObjectFitMath$Showside.fitAndPosition({
    width: smallContainer.width,
    height: smallContainer.height
  }, naturalSize, smallFitRule);
  var sx = smallContainer.width / largeFit.width;
  var sy = smallContainer.height / largeFit.height;
  var tx = (smallContainer.x - largeContainer.x | 0) - largeFit.x | 0;
  var ty = (smallContainer.y - largeContainer.y | 0) - largeFit.y | 0;
  var invSx = smallFit.width / smallContainer.width;
  var invSy = smallFit.height / smallContainer.height;
  return render2(sx, sy, tx, ty, invSx, invSy);
}
RectToRectTransition.displayName = "RectToRectTransition";
var make = RectToRectTransition;
export { make };
/* react Not a pure module */